function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.01172 4.125L3.10547 5.85938L12 9.90234L15.4375 8.33984L7.01172 4.125Z",
  fill: "#4C86B7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.7812 7.27344L20.8945 5.85938L12.4062 2.08594C12.1484 1.97266 11.8516 1.97266 11.5938 2.08594L9.37891 3.07422L17.7812 7.27344Z",
  fill: "#4C86B7"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13 11.6445V21.6484L21.4062 17.9141C21.7695 17.7539 22 17.3945 22 17V7.55469L13 11.6445Z",
  fill: "#4C86B7"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11 11.6445L2 7.55469V17C2 17.3984 2.23047 17.7539 2.59375 17.9141L11 21.6484V11.6445ZM4 14V11L9 13V16L4 14Z",
  fill: "#4C86B7"
});

function SvgPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/Plan.c2b4f3cb.svg";
export { ForwardRef as ReactComponent };